import { render } from "./AgendaPreview.vue?vue&type=template&id=967ce90a&scoped=true"
import script from "./AgendaPreview.vue?vue&type=script&lang=js"
export * from "./AgendaPreview.vue?vue&type=script&lang=js"

import "./AgendaPreview.vue?vue&type=style&index=0&id=967ce90a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-967ce90a"]])

export default __exports__